/*
 * PDP: Versandzeile + Info-Fenster, Liefertermin ("Lieferung Do, 08.10. – Fr, 09.10. · nach 84028")
 * und Versandfrei-Balken.
 *
 * Markup und Konfiguration: snippets/altruan-pdp-versand.liquid. Versandzeile und Lieferzeit sind
 * eigene Blöcke im Theme-Editor und sitzen meist im Preisblock, den product-info.js beim
 * Variantenwechsel neu rendert. Neue Teile werden deshalb per MutationObserver eingehängt.
 *
 * - Versandzeile: Tarif des Markts aus der Konfiguration. Ist die Freigrenze mit Warenkorb plus
 *   aktueller Auswahl erreicht, steht dort "Versandkostenfrei".
 * - Liefertermin: fertiges label der Shipping-App, gemeinsam mit den Produktkarten über
 *   assets/altruan-lieferdatum.js (Lager/Lieferzeit-Ware nach Bestand und custom.always_available der
 *   Variante). Die Pill zeigt nur den Termin, der Ort steht daneben als Link zum Ändern
 *   (snippets/altruan-lieferort.liquid); ein neuer Lieferort lädt neu.
 *   Bei gemessenen Laufzeiten (delivery_source "measured") ein ⓘ mit Hinweis: Region (postal_region,
 *   z. B. "94xxx") und Bestellschluss-Uhrzeit (order_cutoff_at, Berliner Zeit). Nur für Lagerware:
 *   Lieferzeit-Ware rechnet die App ab dem Versand nach Wareneingang, da gilt kein Bestellschluss.
 * - Balken: Warenkorb aus /cart.js, Auswahl aus dem Brutto-Gesamtpreis im Preisblock
 *   ([data-role="gross-price"], wird von price-slider.liquid bei Menge/Staffel aktualisiert).
 * - Brutto/Netto: Gerechnet wird immer brutto. Steht der Schalter (window.AltruanPriceMode) auf netto,
 *   werden Bruttobeträge (DE-Tarif, Freigrenze, Balken) nur für die Anzeige durch den Steuersatz geteilt.
 *   Ohne Schalter bleibt alles brutto.
 */
(() => {
  if (window.altruanPdpVersand) return;
  window.altruanPdpVersand = true;

  const ROWS = [
    ["DACH", ["DE", "AT", "CH"]],
    ["EU", ["EU"]],
    ["INT", ["INT"]],
  ];

  const tpl = (str, vars) => String(str || "").replace(/__(\w+?)__/g, (m, k) => (k in vars ? vars[k] : m));

  // Betrag aus formatiertem Text ("1.234,56 €", "€1,234.56", "CHF 12.50") → Zahl
  const parseMoney = (text) => {
    const raw = String(text || "").replace(/[^\d.,]/g, "");
    if (!raw) return null;
    const lastSep = Math.max(raw.lastIndexOf(","), raw.lastIndexOf("."));
    if (lastSep < 0 || raw.length - lastSep - 1 === 3) return Number(raw.replace(/[.,]/g, ""));
    return Number(raw.slice(0, lastSep).replace(/[.,]/g, "") + "." + raw.slice(lastSep + 1));
  };

  // Seitenweiter Zustand: eine Hauptprodukt-PDP, beliebig viele Teile (ship / lieferung / freebar)
  const state = { cfg: null, cart: null, selection: 0, variantId: null, priceWrap: null };
  const parts = { ship: [], lieferung: [], freebar: [] };

  const readCfg = (el) => {
    try {
      return JSON.parse(el.querySelector("[data-pdp-versand-config]").textContent);
    } catch (_) {
      return null;
    }
  };

  const t = () => state.cfg.t;
  const locale = () => state.cfg.locale || document.documentElement.lang || "de";
  const rate = () => state.cfg.rates[state.cfg.market] || null;

  const money = (value) => {
    try {
      return new Intl.NumberFormat(locale(), { style: "currency", currency: "EUR" }).format(value);
    } catch (_) {
      return value.toFixed(2) + " €";
    }
  };

  // Anzeige eines Bruttobetrags im gewählten Modus (Brutto/Netto-Schalter)
  const isNet = () => {
    const pm = window.AltruanPriceMode;
    return !!(pm && pm.get() === "net" && Number(pm.rate) > 1);
  };
  const gmoney = (value) => money(isNet() ? value / Number(window.AltruanPriceMode.rate) : value);
  // Tarif: Bruttotarife folgen dem Schalter, Nettotarife (AT/CH) bleiben netto
  const rateMoney = (r) => (r.gross ? gmoney(r.rate) : money(r.rate));

  // Nur schreiben, wenn sich etwas ändert: die Teile sitzen im Preisblock, den ein
  // MutationObserver beobachtet.
  const setHtml = (el, html) => {
    if (el.__pvHtml !== html) {
      el.__pvHtml = html;
      el.innerHTML = html;
    }
  };

  const alive = (list) => list.filter((el) => el.isConnected);

  // ---------- Versandzeile ----------
  const rateDetail = (r) =>
    [r.per === "order" ? t().perOrder : t().perParcel, r.gross && !isNet() ? t().gross : t().net]
      .concat(r.free != null ? [tpl(t().freeFrom, { amount: gmoney(r.free) })] : [])
      .join(" · ");

  const lineHtml = () => {
    const r = rate();
    if (!r) return t().lineUnknown;
    const total = (state.cart || 0) + state.selection;
    if (r.free != null && total >= r.free) return tpl(t().lineFree, { country: t().markets[state.cfg.market] });
    let suffix = "";
    if (r.per === "parcel") suffix = ` ${t().perParcel}${r.gross ? "" : ", " + t().net}`;
    if (r.free != null) suffix += " · " + tpl(t().freeFrom, { amount: gmoney(r.free) });
    return tpl(t().line, { amount: rateMoney(r) }) + suffix;
  };

  const popHtml = () => {
    let html = "";
    ROWS.forEach(([group, keys]) => {
      html += `<p class="pdp-ship__group">${t().groups[group]}</p>`;
      keys.forEach((key) => {
        const r = state.cfg.rates[key];
        const value = r ? `${rateMoney(r)}<small>${rateDetail(r)}</small>` : t().inCheckout;
        const isCurrent = key === state.cfg.market;
        const here = isCurrent ? ` <span class="pdp-ship__here">${t().here}</span>` : "";
        html += `<div class="pdp-ship__row${isCurrent ? " is-current" : ""}"><span>${t().markets[key]}${here}</span><span>${value}</span></div>`;
      });
    });
    return html;
  };

  const setPop = (el, open, focusBack) => {
    const pop = el.querySelector("[data-pdp-ship-pop]");
    const btn = el.querySelector("[data-pdp-ship-btn]");
    pop.hidden = !open;
    btn.setAttribute("aria-expanded", String(open));
    if (open) el.querySelector("[data-pdp-ship-close]").focus();
    else if (focusBack) btn.focus();
  };

  const mountShip = (el) => {
    setHtml(el.querySelector("[data-pdp-ship-rows]"), popHtml());
    const btn = el.querySelector("[data-pdp-ship-btn]");
    btn.hidden = false;
    btn.addEventListener("click", () => setPop(el, el.querySelector("[data-pdp-ship-pop]").hidden, true));
    el.querySelector("[data-pdp-ship-close]").addEventListener("click", () => setPop(el, false, true));
  };

  const renderShips = () => {
    parts.ship = alive(parts.ship);
    const html = lineHtml();
    const rows = popHtml();
    parts.ship.forEach((el) => {
      setHtml(el.querySelector("[data-pdp-ship-line]"), html);
      setHtml(el.querySelector("[data-pdp-ship-rows]"), rows);
    });
  };

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    parts.ship.forEach((el) => {
      if (!el.querySelector("[data-pdp-ship-pop]").hidden) setPop(el, false, true);
    });
  });
  document.addEventListener("click", (e) => {
    parts.ship.forEach((el) => {
      const pop = el.querySelector("[data-pdp-ship-pop]");
      if (!pop.hidden && !pop.contains(e.target) && !el.querySelector("[data-pdp-ship-btn]").contains(e.target)) {
        setPop(el, false, false);
      }
    });
  });

  // ---------- Liefertermin + ⓘ ----------
  let tipCounter = 0;

  // "2026-10-21T13:00:00+02:00" → "13:00" (Uhrzeit des Bestellschlusses in Berlin)
  const cutoffTime = (iso) => {
    const at = Date.parse(iso || "");
    if (Number.isNaN(at)) return "13:00";
    try {
      return new Intl.DateTimeFormat("de-DE", { hour: "2-digit", minute: "2-digit", timeZone: "Europe/Berlin" }).format(
        new Date(at),
      );
    } catch (_) {
      return "13:00";
    }
  };

  const setTip = (el, open) => {
    const wrap = el.querySelector("[data-pdp-lieferung-info]");
    if (!wrap) return;
    wrap.classList.toggle("is-open", open);
    wrap.querySelector("[data-pdp-lieferung-info-btn]").setAttribute("aria-expanded", String(open));
  };

  const renderInfo = (el, info, inStock) => {
    const wrap = el.querySelector("[data-pdp-lieferung-info]");
    if (!wrap) return;
    const show = info.source === "measured" && inStock;
    wrap.hidden = !show;
    if (!show) return setTip(el, false);
    const time = cutoffTime(info.cutoffAt);
    const tip = wrap.querySelector("[data-pdp-lieferung-tip]");
    tip.textContent = info.region
      ? tpl(t().deliveryInfoRegion, { region: info.region, time })
      : tpl(t().deliveryInfo, { time });
    if (!tip.id) {
      tipCounter += 1;
      tip.id = `PdpLieferungTip-${tipCounter}`;
      wrap.querySelector("[data-pdp-lieferung-info-btn]").setAttribute("aria-describedby", tip.id);
    }
    if (!wrap.dataset.bound) {
      wrap.dataset.bound = "1";
      wrap.querySelector("[data-pdp-lieferung-info-btn]").addEventListener("click", () => {
        setTip(el, !wrap.classList.contains("is-open"));
      });
    }
  };

  // "Lieferung Mi, 04.11. · nach 84307 Eggenfelden" → "Lieferung Mi, 04.11.": der Ort steht schon im
  // Lieferort-Link daneben. Bei einem Zeitraum ("Mi, 04.11. – Do, 05.11.", z. B. ohne Lieferort) entfällt
  // das erste Wort, damit Link und ⓘ in die Zeile passen; der Lkw sagt es, Screenreader hören es weiter.
  const renderDate = (el, label) => {
    if (el.dataset.label === label) return;
    el.dataset.label = label;
    const when = label.split(" · ")[0];
    const lead = when.includes(" – ") ? (when.match(/^\S+\s(?=\S+,\s)/) || [""])[0] : "";
    el.textContent = when.slice(lead.length);
    if (lead) {
      const sr = document.createElement("span");
      sr.className = "visually-hidden";
      sr.textContent = lead;
      el.prepend(sr);
    }
  };

  const renderLieferungen = () => {
    parts.lieferung = alive(parts.lieferung);
    if (!parts.lieferung.length) return;
    const variantId = state.variantId;
    const v = state.cfg.variants[variantId] || {};
    const inStock = Number(v.qty) > 0 || v.always === true;
    if (!window.AltruanLieferdatum) return;
    window.AltruanLieferdatum.info({ country: state.cfg.country, inStock, locale: locale() }).then((info) => {
      if (variantId !== state.variantId) return;
      parts.lieferung.forEach((el) => {
        const p = el.querySelector("[data-pdp-lieferung]");
        if (!info) {
          p.hidden = true;
          return;
        }
        p.classList.toggle("pdp-lieferung--stock", inStock);
        p.classList.toggle("pdp-lieferung--backorder", !inStock);
        renderDate(el.querySelector("[data-pdp-lieferung-date]"), info.label);
        renderInfo(el, info, inStock);
        p.hidden = false;
      });
    });
  };

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    parts.lieferung.forEach((el) => setTip(el, false));
  });
  document.addEventListener("click", (e) => {
    parts.lieferung.forEach((el) => {
      const wrap = el.querySelector("[data-pdp-lieferung-info]");
      if (wrap && wrap.classList.contains("is-open") && !wrap.contains(e.target)) setTip(el, false);
    });
  });

  // ---------- Versandfrei-Balken ----------
  const renderFreebars = () => {
    parts.freebar = alive(parts.freebar);
    const r = rate();
    if (!r || r.free == null || state.cart == null) return;
    const F = r.free;
    const cart = state.cart;
    const withSel = cart + state.selection;
    const reached = cart >= F;

    parts.freebar.forEach((freebar) => {
      const q = (sel) => freebar.querySelector(sel);
      freebar.classList.toggle("is-free", reached);
      q("[data-pdp-freebar-text]").innerHTML = reached
        ? t().fbReached
        : cart === 0
          ? tpl(t().fbEmpty, { amount: gmoney(F) })
          : tpl(t().fbRest, { amount: gmoney(F - cart) });
      q("[data-pdp-freebar-goal]").textContent = gmoney(F);
      q("[data-pdp-freebar-cart]").style.width = Math.min(100, (cart / F) * 100) + "%";
      q("[data-pdp-freebar-sel]").style.width = Math.min(100, (withSel / F) * 100) + "%";

      let hint = cart > 0 ? tpl(t().fbCart, { amount: gmoney(cart) }) + " " : "";
      if (!reached) hint += withSel >= F ? t().fbSelFree : tpl(t().fbSelRest, { amount: gmoney(F - withSel) });
      q("[data-pdp-freebar-hint]").innerHTML = hint;
      freebar.hidden = false;
    });
  };

  // ---------- Warenkorb und Auswahl ----------
  const priceContainer = () => (state.priceWrap || document).querySelector(".product-price-container");

  // Shop-Preise sind netto; Steuersatz wie im Preisblock (data-tax-price / data-price, beides Cent)
  const taxRate = () => {
    const pc = priceContainer();
    if (state.cfg.taxesIncluded || !pc) return 1;
    const net = Number(pc.dataset.price);
    const gross = Number(pc.dataset.taxPrice);
    return net > 0 && gross > 0 ? gross / net : 1;
  };

  const renderAll = () => {
    renderShips();
    renderFreebars();
  };

  const loadCart = () => {
    if (!rate()) return;
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : "/cart") + ".js", {
      headers: { Accept: "application/json" },
    })
      .then((res) => (res.ok ? res.json() : null))
      .then((cart) => {
        if (!cart) return;
        state.cart = Math.round(((cart.total_price || 0) / 100) * taxRate() * 100) / 100;
        renderAll();
      })
      .catch(() => {});
  };

  const readSelection = () => {
    const pc = priceContainer();
    const el = pc && pc.querySelector('[data-role="gross-price"]');
    const value = el ? parseMoney(el.textContent) : null;
    state.selection = value && isFinite(value) ? value : 0;
    renderAll();
  };

  // ---------- Einhängen ----------
  // Neue Teile finden (erster Aufruf, Variantenwechsel ersetzt den Preisblock, Theme-Editor).
  const mount = () => {
    let fresh = false;
    let freshVariant = null;
    document.querySelectorAll("[data-pdp-part]:not([data-pv-ready])").forEach((el) => {
      const cfg = readCfg(el);
      if (!cfg) return;
      el.setAttribute("data-pv-ready", "");
      if (!state.cfg || String(state.cfg.productId) !== String(cfg.productId)) {
        state.cfg = cfg;
        state.variantId = cfg.variantId;
        state.cart = null;
      } else {
        state.cfg.variants = cfg.variants;
      }
      // Frisch gerenderter Preisblock steht auf der gewählten Variante
      if (el.closest('[id^="price-"][role="status"]')) freshVariant = cfg.variantId;
      const type = el.getAttribute("data-pdp-part");
      if (type === "ship") mountShip(el);
      if (parts[type]) parts[type].push(el);
      fresh = true;
    });
    if (!fresh) return false;
    if (freshVariant) state.variantId = freshVariant;
    renderLieferungen();
    return true;
  };

  const observe = () => {
    const wrap =
      document.querySelector('product-info [id^="price-"][role="status"]') ||
      document.querySelector('[id^="price-"][role="status"]');
    if (!wrap || wrap === state.priceWrap) return;
    state.priceWrap = wrap;
    new MutationObserver((records) => {
      const foreign = records.some((r) => {
        const node = r.target.nodeType === 1 ? r.target : r.target.parentElement;
        return !(node && node.closest("[data-pdp-part]"));
      });
      if (!foreign) return;
      mount();
      readSelection();
    }).observe(wrap, { childList: true, characterData: true, subtree: true });
  };

  const start = () => {
    if (!mount()) return;
    observe();
    readSelection();
    if (state.cart == null) loadCart();
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();

  document.addEventListener("shopify:section:load", start);
  document.addEventListener("price-mode:change", () => {
    if (state.cfg) renderAll();
  });
  document.addEventListener("altruan-lieferort:change", () => {
    if (state.cfg) renderLieferungen();
  });

  // ---------- Theme-Events ----------
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, loadCart);
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event && event.data && event.data.variant;
      if (!variant || !variant.id || !state.cfg) return;
      if (variant.product_id && String(variant.product_id) !== String(state.cfg.productId)) return;
      state.variantId = variant.id;
      renderLieferungen();
    });
  }
})();
